import { BrowserRouter } from 'react-router-dom'
import Route from 'Route'

import { ApolloProvider } from '@apollo/client'
import * as Sentry from '@sentry/react'

import './i18n'

import useDetectMobile from 'hooks/useDetectMobile'
import useApollo from 'hooks/useApollo'

import ModalsProvider from 'providers/ModalsProvider'
import AuthProvider from 'providers/AuthProvider'

import './App.css'

import { LayoutProvider } from 'providers/LayoutProvider'
import { AppModeContextProvider } from 'context/AppModeContext'
import { WindowContextProvider } from 'context/WindowContext'

function App() {
    useDetectMobile()

    const client = useApollo()

    return (
        <Sentry.ErrorBoundary>
            <ApolloProvider client={client}>
                <WindowContextProvider>
                    <ModalsProvider>
                        <BrowserRouter>
                            <AuthProvider>
                                <AppModeContextProvider>
                                    <LayoutProvider>
                                        <Route />
                                    </LayoutProvider>
                                </AppModeContextProvider>
                            </AuthProvider>
                        </BrowserRouter>
                    </ModalsProvider>
                </WindowContextProvider>
            </ApolloProvider>
        </Sentry.ErrorBoundary>
    )
}

export default App
